import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'TrendDecoration',
  components: {
    MdmStripe: MdmStripe
  },
  props: {
    trends: {
      type: Object,
      required: true
    }
  },
  computed: {
    trend: function trend() {
      var _Object$values = Object.values(this.trends),
          _Object$values2 = _slicedToArray(_Object$values, 1),
          _Object$values2$ = _Object$values2[0],
          trend = _Object$values2$ === void 0 ? {} : _Object$values2$;

      return trend;
    }
  }
};